import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

/**
 * 全画面ローディングオーバーレイコンポーネント
 * @param {boolean} loading - ローディング状態
 * @param {string} message - 表示メッセージ（オプション）
 * @param {number} zIndex - z-index値（デフォルト: 9999）
 * @param {string} backdropColor - 背景色（デフォルト: 'rgba(255, 255, 255, 0.7)'）
 * @param {number} size - CircularProgressのサイズ（デフォルト: 40）
 * @param {boolean} fadeIn - フェードインアニメーション（デフォルト: true）
 */
export const FullScreenCircularLoading = ({
    loading,
    zIndex = 9999,
    backdropColor = 'rgba(255, 255, 255, 0.7)',
    size = 40,
    fadeIn = true
}) => {
    if (!loading) return null;

    const content = (
        <Box
            position="fixed"
            top={0}
            left={0}
            width="100vw"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor={backdropColor}
            zIndex={zIndex}
            gap={2}
        >
            <CircularProgress size={size} />
        </Box>
    );

    return fadeIn ? <Fade in={loading}>{content}</Fade> : content;
};

export default FullScreenCircularLoading;